<template>
  <v-content app>
    <v-container fluid>
      <v-layout>
        <v-flex sm12>
          <v-breadcrumbs class="pb-1" icons divider=">">
            <v-breadcrumbs-item>
              <div class="text-uppercase">EDIT PROFILE</div>
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
      <v-card class="v-card---style">
        <v-layout row wrap> 
          <v-flex xs12>
            <v-card flat>
              <section>
                <div class="flex-it">
                  <v-icon class="ltp-blue mr-2" size="40">account_circle</v-icon>
                  <div @click="is_editing = true" v-if="!is_editing">
                    <v-toolbar flat color="white">
                      <v-toolbar-title class="user-name__title">{{ user_info.username }}</v-toolbar-title>
                      <v-icon class="ml-3 mt-2" size="24" color="gray">edit</v-icon>
                    </v-toolbar>
                  </div>
                  <div v-else>
                    <v-toolbar flat color="white">
                      <div class="flex-it">
                        <v-text-field
                          class="editing-name--style"
                          placeholder="First and last name"
                          single-line
                          v-model="user_info.username"
                        ></v-text-field>
                        <button class="no-outline">
                          <v-icon @click.native="editName" class="edit-button">check</v-icon>
                        </button>
                        <button class="no-outline" @click.native="is_editing = false">
                          <v-icon @click.native="is_editing = false" color="#ff8e7f">close</v-icon>
                        </button>
                      </div>
                    </v-toolbar>
                  </div>
                </div>
                <div class="pt-4 pb-4">
                  <div class="pb-2 bold edit-account__subtitle">
                    Account Info
                  </div>
                  <div class="mb-2">
                    <span class="text-ltp"><strong>E-mail:</strong> </span><span> {{ user_info.email }}</span>
                  </div>
                  <div>
                      <span
                        class="text-ltp"><strong>Account Type:</strong> </span><span> <span v-if="user_info.is_admin"> Admin</span><span
                    v-if="!user_info.is_admin"> Staff</span></span>
                  </div>
                </div>
              </section>
              <section class="pb-5">
                <v-layout row wrap>
                  <v-flex xs12>
                    <ul class="tabs-wrapper-2 flex-it reset-list mt-3">
                      <li class="bold" v-for="tab in user_tabs" @click="selectedComponent = tab.component"
                          :class="{'active-tab': selectedComponent === tab.component}">{{ tab.name }}
                      </li>
                    </ul>
                    <keep-alive>
                      <component
                        :user_info="user_info"
                        :is="selectedComponent"></component>
                    </keep-alive>
                  </v-flex>
                </v-layout>
              </section>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card>
    </v-container>
  </v-content>
</template>

<style lang="scss">

  .ltp-blue {
    color: #0033a0 !important;
  }

  .primary--text {
    color: #0033a0 !important;
    caret-color: #0033a0 !important;
  }

  .v-card---style {
    padding: 15px 30px 30px 30px;
  }

  .v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
    margin-left: 15px !important;
  }

  .v-breadcrumbs__item {
    color: gray;
    font-size: 12px;
  }

  .container {
    padding: 15px 24px 24px 24px !important;
  }

  .v-breadcrumbs {
    padding: 0 !important;
    margin-bottom: 10px !important;
  }

  .v-toolbar__content {
    padding: 0 !important;
  }

  .bold {
    font-weight: bold;
  }

  .text-ltp {
    color: #0033A0;
  }

  .no-outline {
    outline: 0;
  }

  .edit-button {
    background: #00c8536b;
    color: white !important;
    border-radius: 2.5px;
    margin: 10px 10px;
  }

  .edit-button:focus {
    outline: 0;
  }

  .editing-name--style {
    padding-top: 20px;
  }

  .editing-name--style > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    color: #0000009c !important;
    font-size: 37px !important;
    padding-bottom: 14px;
  }

  .toast-top-right {
    top: 70px !important;
    right: 23px !important;
  }

  td {
    padding: 15px 0;
  }

  .list--dense .list__tile:not(.list__tile--avatar) {
    height: 50px !important;
  }

  .countries-card--min-height {
    min-height: 305px;
  }

  .flex-it {
    display: flex;
  }

  .tabs-wrapper-2 {
    background: white;
  }

  .tabs-wrapper-2 > li {
    color: #8E8E8F;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
  }

  .tabs-wrapper-2 > .active-tab {
    color: #0033A0;
  }

  .tabs-wrapper-2 > .active-tab::after {
    content: "";
    display: block;
    border-bottom: 2px solid #0033A0;
    position: relative;
    top: 10px;
  }

  .reset-list {
    padding-left: 0;
    list-style-type: none;
  }

  .chart-card {
    padding: 20px;
    background: white;
    margin-bottom: 20px;
  }

  .map-card {
    padding: 20px;
    background: white;
    margin-bottom: 20px;
    height: 308px;
    overflow: hidden;
    position: relative;
  }

  .countries--max-height {
    max-height: 260px;
    overflow-y: scroll;
  }

  .region {
    cursor: pointer;
    font-size: 16px;
    color: #4D4F5C;
    margin-right: 35px;
  }

  .tabs__item--active {
    color: #06B085;
  }

  .list__tile__title {
    color: gray !important;
  }

  .theme--light.application .text--primary {
    color: #7ECEAA !important;
  }

  .edit-account__subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-size: 17px;
  }

  .user-name__title {
    color: #0000009c;
    font-size: 37px;
    margin-left: 0 !important;
    font-family: 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif;
  }

  .container {
    padding: 15px 24px 24px 24px !important;
  }

  .v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
    margin-left: 20px;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'
  import ChangePassword from "../components/edit-account/ChangePassword";

  export default {
    components: {
      ChangePassword
    },
    data: () => ({
      user_info: "",
      is_editing: false,
      selectedComponent: 'ChangePassword',
      user_tabs: [
        {name: "Change password", component: "ChangePassword", id: 2}
      ],
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }),

    created() {
      this.getCurrentUser()
    },

    methods: {
      getCurrentUser() {
        const self = this;
        let url = 'me/';
        axiosInstance.get(url).then(function (response) {
          self.user_info = response.data;
        }).catch(function (error) {
          console.log(error)
        })
      },
      editName() {
        this.is_editing = false;
        let self = this,
          url = 'workspaces/' + parseInt(self.$route.params.workspace_id) + '/users/';

        self.is_loading = true;

        let params = {
          username: self.user_info.username
        };

        axiosInstance.put(url, params).then(function () {
          //  self.is_loading = false;
          self.$toastr.s("Changed user name successfully");
        }).catch(function (err) {
          //  self.is_loading = false;
          self.$toastr.e("Error changing user name");
          console.log(err)
        });
      }
    },
    computed: {
      actual_user_name() {
        return this.user_info.first_name + ' ' + this.user_info.last_name
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/EditProfile.vue